import { useEffect, useState } from "react";
import { Calculator } from "./components/Calculator";
import { AuthProvider } from "./auth/AuthProvider";
import { Header } from "./components/Header";
import { ShareDialog } from "./components/ShareDialog";
import { SharedSessionViewer } from "./components/SharedSessionViewer";
import { useThemeStore } from "./store/themeStore";
import { useSessionSync } from "./hooks/useSessionSync";
import { useKeyboardShortcuts } from "./hooks/useKeyboardShortcuts";
import { useWorkspaceInit } from "./hooks/useWorkspace";

function getSharedToken(): string | null {
  const match = window.location.pathname.match(/^\/shared\/([a-f0-9-]+)$/i);
  return match ? match[1] : null;
}

function AppShell({ children }: { children: React.ReactNode }) {
  useSessionSync();
  useKeyboardShortcuts();
  useWorkspaceInit(); // Restore the persisted local workspace folder
  return <>{children}</>;
}

export function App() {
  const theme = useThemeStore((state) => state.theme);
  const [sharedToken] = useState(() => getSharedToken());

  // Apply theme on mount and when theme changes
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  // Shared session view — minimal chrome
  if (sharedToken) {
    return (
      <AuthProvider>
        <AppShell>
          <div className="app">
            <Header />
            <SharedSessionViewer token={sharedToken} />
            <ShareDialog />
          </div>
        </AppShell>
      </AuthProvider>
    );
  }

  return (
    <AuthProvider>
      <AppShell>
        <div className="app">
          <Header />
          <Calculator />
          <ShareDialog />
        </div>
      </AppShell>
    </AuthProvider>
  );
}
